export default __webpack_public_path__ + "images/br_flag.png";